const Footer = () => {
    return (
        <div className="footer">
            <a className="link" href="https://ticket.pt" target="_blank" rel="noreferrer">
                TICKET SERVIÇOS&reg;
            </a>
            <div className="flex flex-ai-c flex-jc-c mt-1">
                <p>Powered by&nbsp;</p>
                <a href="https://paycritical.com/" target="_blank" rel="noreferrer" className="flex flex-ai-c">
                    <img src="assets/logos/paycritical-logo.svg" alt="Paycritical" />
                </a>
            </div>
        </div>
    );
};

export default Footer;
